var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentSpend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 65,
    viewBox: "0 0 67 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 33.3818,
    cy: 32.5,
    rx: 33.3818,
    ry: 32.5,
    fill: "#39B54A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1325 35.332H19.6825C17.8491 35.332 16.3491 36.832 16.3491 38.6654V46.9987C16.3491 47.9154 17.0991 48.6654 18.0158 48.6654H24.1325C25.0491 48.6654 25.7991 47.9154 25.7991 46.9987V36.9987C25.7991 36.082 25.0491 35.332 24.1325 35.332Z",
    fill: "#095228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2321 28.668H30.7821C28.9487 28.668 27.4487 30.168 27.4487 32.0013V47.0013C27.4487 47.918 28.1987 48.668 29.1154 48.668H36.8987C37.8154 48.668 38.5654 47.918 38.5654 47.0013V32.0013C38.5654 30.168 37.0821 28.668 35.2321 28.668Z",
    fill: "#095228"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3491 40.332H41.8991C40.9824 40.332 40.2324 41.082 40.2324 41.9987V46.9987C40.2324 47.9154 40.9824 48.6654 41.8991 48.6654H48.0158C48.9324 48.6654 49.6824 47.9154 49.6824 46.9987V43.6654C49.6824 41.832 48.1824 40.332 46.3491 40.332Z",
    fill: "#095228"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0324 20.0815C38.549 19.5648 38.749 18.9482 38.5824 18.4148C38.4157 17.8815 37.899 17.4982 37.1657 17.3815L35.5657 17.1148C35.499 17.1148 35.349 16.9982 35.3157 16.9315L34.4324 15.1648C33.7657 13.8148 32.249 13.8148 31.5824 15.1648L30.699 16.9315C30.6824 16.9982 30.5324 17.1148 30.4657 17.1148L28.8657 17.3815C28.1324 17.4982 27.6324 17.8815 27.449 18.4148C27.2824 18.9482 27.4824 19.5648 27.999 20.0815L29.2324 21.3315C29.299 21.3815 29.349 21.5815 29.3324 21.6482L28.9824 23.1815C28.7157 24.3315 29.149 24.8482 29.4324 25.0482C29.7157 25.2482 30.3324 25.5148 31.349 24.9148L32.849 24.0315C32.9157 23.9815 33.1324 23.9815 33.199 24.0315L34.6824 24.9148C35.149 25.1982 35.5324 25.2815 35.8324 25.2815C36.1824 25.2815 36.4324 25.1482 36.5824 25.0482C36.8657 24.8482 37.299 24.3315 37.0324 23.1815L36.6824 21.6482C36.6657 21.5648 36.7157 21.3815 36.7824 21.3315L38.0324 20.0815Z",
    fill: "#095228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentSpend);
export default __webpack_public_path__ + "static/media/current-spend.9295b8699e514dcb6d838d64c5534455.svg";
export { ForwardRef as ReactComponent };